module.exports = __webpack_public_path__ + "img/logo带白空边.44cc76cd.png";